// turbo cache test: web-app touch
/* import "./globals.css"; */
/* import "@acme/design-system/styles.css"; */
import "@acme/ui/styles.css";
// import "./paraglide/init.js";
import "@acme/i18n";
import React, { Suspense, useEffect, useRef } from "react";
import { createRoot } from "react-dom/client";
import { createRouter } from "./router.js";
import { RouterProvider } from "@tanstack/react-router";
import { Toaster } from "@acme/ui/sonner";
import { Spinner } from "@acme/ui/spinner";
import { AuthContext } from "./features/auth/_providers/auth.provider.js";
import { AuthSessionGate } from "./features/auth/_components/auth-session-gate.js";
import { useContextAndErrorIfNull } from "./common/hooks/use-context-and-error-if-null.js";

// import "../dist/globals.css";

// import { supabase } from "~/lib/supabase.ts";
//TODO: env is not in use for now
// import { env, isProduction } from "@acme/env/client";
//TODO: add formbricks
// import formbricks from "@formbricks/js";
//TODO: add sentry
// import {
//   init as initializeSentry,
//   browserTracingIntegration,
//   tanstackRouterBrowserTracingIntegration,
// } from "@sentry/react";
//TODO: I think we dont need nuqs anymore because tanstack has better solution
// import { NuqsAdapter } from "nuqs/adapters/react";
//TODO: add posthog
// import { posthog } from "posthog-js";
// import { PostHogProvider } from "posthog-js/react";
// TODO: hceck theming logic (we dont need mantine stuff anymway so keep it clean for only hold our tailwind based theming)
//TODO: add custom theming provider
// import { CustomThemingProvider } from "./providers/CustomThemingProvider.tsx";

// if (typeof window !== "undefined")
// {
//   // debug is not available anymore, instead now you have to append ?formbricksDebug=true to the URL
//   formbricks
//     .setup({
//       appUrl: env.PUBLIC_WEBAPP_FORMBRICKS_HOST,
//       environmentId: env.PUBLIC_WEBAPP_FORMBRICKS_ENVIRONMENT_ID,
//     })
//     .then(() => console.log("Formbricks initialized"))
//     .catch((error) => console.error("Error initializing Formbricks", error));
// }
// if (env.PUBLIC_WEBAPP_POSTHOG.isEnabled)
// {
//   // api_host needs to match vercel and vite rewrite/proxy path in vite.config.ts
//   posthog.init(env.PUBLIC_WEBAPP_POSTHOG.key, {
//     api_host: `${env.PUBLIC_WEBAPP_URL}/ph`,
//     debug: env.PUBLIC_WEBAPP_POSTHOG.debug,
//     persistence: "localStorage",
//     ui_host: "https://eu.posthog.com",
//   });
// }
// if (isProduction)
// {
//   initializeSentry({
//     dsn: "https://5ede381826fa053570c6648f272ed4af@o4509301496610816.ingest.de.sentry.io/4509301497790544",
//     integrations: [browserTracingIntegration(), tanstackRouterBrowserTracingIntegration(router)],
//     sendDefaultPii: true,
//     tracesSampleRate: 1.0,
//   });
// }

export const router = createRouter();

const rootElement = document.getElementById("root");

if (!rootElement)
{
  throw new Error("Root element not found!");
}

// Register service worker for Firebase Cloud Messaging
if ("serviceWorker" in navigator)
{
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) =>
    {
      window.addEventListener("online", () =>
      {
        registration.update();
      });
      return navigator.serviceWorker.ready;
    })
    .catch((error) =>
    {
      console.error("❌ Service Worker registration failed:", error);
    });
}

function InnerApp()
{
  const authContext = useContextAndErrorIfNull(AuthContext);
  const prevAuthenticatedRef = useRef<boolean | undefined>(authContext.isAuthenticated);

  useEffect(() =>
  {
    const isAuthenticated = authContext.isAuthenticated;
    if (prevAuthenticatedRef.current !== isAuthenticated)
    {
      prevAuthenticatedRef.current = isAuthenticated;
      void router.invalidate();
    }
  }, [authContext.isAuthenticated]);

  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center bg-background">
          <Spinner className="size-8 text-muted-foreground" />
        </div>
      }>
      <RouterProvider router={router} context={{ auth: authContext }} />
      <Toaster />
    </Suspense>
  );
}

function App()
{
  return <InnerApp />;
}

if (!rootElement.innerHTML)
{
  const root = createRoot(rootElement);

  /* 
  authClient
    .getSession()
    .then((getSessionResult) =>
    {
      const initialSession = getSessionResult.data ?? null;

      if (getSessionResult.error)
      {
        console.error("Error getting initial session", getSessionResult.error);
      }
      // else
      // {
      //   if (initialSession)
      //   {
      //     console.log("initial session found");
      //     console.log(initialSession);
      //   }
      // }

      root.render(
        <React.StrictMode>
          {/* <PostHogProvider client={posthog}>
          <AuthProvider initialSession={initialSession}>
            <NuqsAdapter>
            <CustomThemingProvider>
            <App />
            </CustomThemingProvider>
             </NuqsAdapter>
          </AuthProvider>
           </PostHogProvider>
        </React.StrictMode>
      );

       setTimeout(() =>
      {
        // remove the initial loading indicator after 3 seconds to have a smooth transition between the initial loading indicator and the react loading state

        const initialLoadingIndicator = document.getElementById("initial-loading-indicator");

        if (!initialLoadingIndicator)
        {
          console.error("Initial loading indicator not found. Did you change the id of the element?");
        }
        else
        {
          initialLoadingIndicator.remove();
        }
      }, 3000); 
    })
    .catch((error) =>
    {
      console.error("Something went wrong while getting the initial session and user", error);
      process.exit(1);
    });
  */

  root.render(
    <React.StrictMode>
      <AuthSessionGate>
        <App />
      </AuthSessionGate>
    </React.StrictMode>
  );
}
